import { Space } from 'antd';
import styled from 'styled-components';

export const StyledSpace = styled(Space)`
  position: relative;
  z-index: 2;
`;
